export default function SmartRegenerateActions({ onRegenerate, loading = false, preview }) {
    if (!preview) return null;

    const actions = [
        { key: "cta", label: "Improve CTA" },
        { key: "industry", label: "Improve Industry Fit" },
        { key: "trust", label: "Improve Trust Signals" },
        { key: "realism", label: "Improve Realism" }
    ];

    return (
        <div className="wg-smart-regen-card">
            <div className="wg-smart-regen-head">
                <h3>Smart Regenerate</h3>
                <p>Improve specific weak areas instead of regenerating blindly.</p>
            </div>

            <div className="wg-smart-regen-actions">
                {actions.map((action) => (
                    <button
                        key={action.key}
                        type="button"
                        className="wg-secondary-btn"
                        disabled={loading}
                        onClick={() => onRegenerate(action.key)}
                    >
                        {action.label}
                    </button>
                ))}
            </div>
        </div>
    );
}